import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const removeUserDocument = options =>
  call(websocketFetch, 'remove_user_document', options);
